import { validateMobile } from "@/utils/regex";
export default {
  props: {},
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!validateMobile(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      
      mobileLoginForm: {
        mobile: "",
        yzm:"",
      },
      mobileRules: {
        mobile: [{ required: true, trigger: "blur", validator: validatePhone }],
        yzm: [{ required: true, trigger: "blur", message:"请输入短信验证码!" }],
      },

      count:'获取验证码',
      showTime:true,
      timer: null,

      
    };
  },
  computed: {},
  created() {

  },
  mounted() {},
  watch: {},
  methods: {
    // 发送验证码
    sendSmsbtn(){     

      this.$http.post(this.$api.sendSms,{"phone":this.mobileLoginForm.mobile},true).then(res =>{
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.showTime = false;
          this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            } else {
            this.showTime = true;
            clearInterval(this.timer);
            this.timer = null;
            this.count = "重新获取验证码"
            }
          }, 1000)
          }
      })
    },
    // 手机号登录
    toMobileLogin(type) {
      this.$refs.mobileLoginForm.validate((valid) => {
        if (valid) {
          // 登录方式 bind为绑定号码时登录接口
          const loginType = type=='bind' ? 'user/bindLogin':'user/login'

          this.$store
            .dispatch(loginType, this.mobileLoginForm)
            .then((res) => {
              console.log("手机号登陆成功", res);
              if(type == 'bind'){ // 绑定需要重新获取下userinfo
                this.$store.dispatch("user/getInfo").then(()=>{
                  this.goToViews();
                });
              }else{
                this.goToViews();
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        } else {
          return false;
        }
      });
    },

    // 根据当前用户的 状态 前往不同页面或操作
    goToViews() {
      this.$router.push({ path: "/user/already" });
      // location.reload();

      // // 若有手机号和姓名
      // if(this.$store.userPhone){
      //   // 默认去用户首页
      //   this.$router.push({ path: "/user/already" });
      // }else{
      //   // 绑定用户
        // location.reload();
      // }
      
      
    },

  },
  components: {},
};